import React from "react"
import { Link } from "gatsby"

import Layout from "../Layout"

import MentorsWithDesc from "../MentorsWithDesc";

import Contact from "../Contact";

import SEO from "../seo"
import MentorsFull from "../MentorsWithDesc"
import useLabels from "../../utils/useLabels"
import labels from "../Mentors/const"
const IndexPage = ({ lang }) => {

  const t = useLabels(labels, lang);

  console.log(t.experts)

  return (
  <Layout lang={lang}>
    <MentorsFull mentors={t.experts} lang={lang} />
    <Contact lang={lang} />
  </Layout>
)}

export default IndexPage
